import React from 'react';
import { ArrowPathIcon, CheckCircleIcon } from '@heroicons/react/24/outline';
import { clsx } from 'clsx';

interface RefreshStatusLoaderProps {
  isVisible: boolean;
  isSuccess: boolean;
  isBackToTopVisible: boolean;
}

export const RefreshStatusLoader: React.FC<RefreshStatusLoaderProps> = ({ isVisible, isSuccess, isBackToTopVisible }) => {
  if (!isVisible) return null;
  return (
    <div className={clsx(
      'absolute bottom-8 z-50 flex items-center gap-2 rounded-lg px-4 py-3 shadow-lg border',
      isSuccess ? 'bg-green-50 border-green-200' : 'bg-gray-50 border-gray-200',
      isBackToTopVisible ? 'right-[88px]' : 'right-8'
    )}>
      {isSuccess ? (
        <>
          <CheckCircleIcon className="h-4 w-4 text-green-600" />
          <span className="text-sm font-medium text-green-600">Statement data refreshed</span>
        </>
      ) : (
        <>
          <ArrowPathIcon className="h-4 w-4 animate-spin text-gray-400" />
          <span className="text-sm font-medium text-gray-400">Statement data is refreshing</span>
        </>
      )}
    </div>
  );
};

